module.exports = __webpack_public_path__ + "static/111_001-89eb7049ce617491ac335643f73c4ca2.jpg";